module.exports = "<router-outlet></router-outlet>\r\n<!-- toastr -->\r\n<ng-snotify></ng-snotify>"